// L'annuaire est passé à React.
//
// Le routeur appelle toujours `rendre(root, ctx)` : il ignore de quel monde
// vient l'écran.
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Membres from "../react/ecrans/Membres.jsx";

export const rendre = vueReact(Membres);
